import { __awaiter } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { useStripe, useElements, PaymentElement } from '../../node_modules/@stripe/react-stripe-js/dist/react-stripe.esm.js';
import { useState, useRef, useEffect } from 'react';
import { useAsync } from '../../utils/hooks/use-async.js';
import 'styled-components';
import { Alert } from '../alert/alert.component.js';
import { Button } from '../button/button.component.js';
import { Loading } from '../loading/loading.component.js';
import { Footer } from './payment-method-form-with-microdeposits.style.js';

const Stripe = ({ children, copy, disabled, loading, onCancel, onReady, onSubmit, paymentMethodOrder, parseError = ({ message }) => {
    // The PaymentElement already displays "incomplete field" errors well; avoid displaying them a second time in the <Alert />.
    if (!message.match(/incomplete|Please provide your full name/))
        return message;
}, redirectUrl, }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [errorMessage, setErrorMessage] = useState('');
    const [showStripeError, setShowStripeError] = useState(false);
    const stripeRef = useRef(stripe);
    const elementRef = useRef(elements);
    const submitButtonRef = useRef(null);
    stripeRef.current = stripe;
    elementRef.current = elements;
    useEffect(() => {
        setTimeout(() => {
            if (!stripeRef.current || !elementRef.current) {
                setShowStripeError(true);
            }
        }, 10000);
    }, []);
    const [{ loading: submitPending, error }, submit] = useAsync(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!stripe || !elements)
            return;
        const result = yield stripe.confirmSetup({
            elements,
            confirmParams: {
                expand: ['payment_method'],
                return_url: redirectUrl,
            },
            redirect: 'if_required',
        });
        if (result.error)
            throw new Error(result.error.message);
        yield onSubmit(result.setupIntent);
    }), submitButtonRef);
    const handleSubmit = (e) => {
        e.preventDefault();
        submit();
    };
    useEffect(() => {
        if (error)
            setErrorMessage(parseError(error));
    }, [error, parseError]);
    if (stripe && elements)
        return (jsxs("form", Object.assign({ onSubmit: handleSubmit }, { children: [jsx(PaymentElement, { onReady: onReady, options: {
                        paymentMethodOrder,
                    } }, void 0), children, jsx(Alert, Object.assign({ margin: { top: '8px' } }, { children: errorMessage }), void 0), jsxs(Footer, Object.assign({ id: "payment-method-footer" }, { children: [jsx(Button, Object.assign({ disabled: disabled || !stripe || !elements, fullWidth: true, loading: loading || submitPending, ref: submitButtonRef, type: "submit" }, { children: copy.submit }), void 0), onCancel && (jsx(Button, Object.assign({ fullWidth: true, margin: { top: '12px' }, onClick: onCancel }, { children: copy.cancel }), void 0))] }), void 0)] }), void 0));
    else if (showStripeError)
        return (jsxs(Fragment, { children: [jsx(Loading, { "data-testid": "stripe-loading" }, void 0), jsx(Alert, { children: copy.error }, void 0)] }, void 0));
    else
        return jsx(Loading, { "data-testid": "stripe-loading" }, void 0);
};

export { Stripe };
